import React from 'react';
import './TaskCard.css';

export default function TaskCard({ children, className = '' }) {
  return (
    <div className={`task-card ${className}`.trim()}>
      {children}
    </div>
  );
}
